import React from 'react';
import './Score.css';

const Score = () => {
  return (
    <section className="score-section">
      <div className="score-container">
        <div className="score-header">
          <h1 className="score-title">Découvrez le Prosperian Score™</h1>
          <p className="score-intro">
            Mesurez votre maturité commerciale avant d'accélérer
          </p>
        </div>

        <div className="score-content">
          <div className="score-section-block">
            <h2 className="section-title">Comment fonctionne le pré-score ?</h2>
            <p className="section-intro">Le Prosperian Pre-Score™ repose sur :</p>
            <ul className="score-list">
              <li>Un questionnaire rapide (7 questions) fondé sur les fondamentaux de la prospection moderne</li>
              <li>Un algorithme de scoring basé sur les données de plusieurs centaines d'entreprises B2B</li>
              <li>Une classification en 3 niveaux de maturité :</li>
            </ul>

            <div className="score-levels">
              <div className="score-level">
                <div className="level-range">0-40 pts</div>
                <div className="level-description">"Fondamentaux à renforcer"</div>
              </div>
              <div className="score-level">
                <div className="level-range">41-70 pts</div>
                <div className="level-description">"Potentiel d'accélération"</div>
              </div>
              <div className="score-level">
                <div className="level-range">71-100 pts</div>
                <div className="level-description">"Prêt pour l'excellence commerciale"</div>
              </div>
            </div>

            <p className="section-conclusion">
              A l'issue, vous recevez un rapport personnalisé avec votre score, un benchmark sectoriel, et les premiers leviers à activer.
            </p>
          </div>

          <div className="score-section-block">
            <h2 className="section-title">Pourquoi c'est utile ?</h2>
            <p className="section-intro">Dans un contexte où la prospection B2B devient plus complexe, digitalisée et exigeante, il est essentiel de savoir :</p>
            <ul className="score-list">
              <li>Où vous en êtes dans votre structuration commerciale</li>
              <li>Quels leviers activer en priorité selon votre niveau de maturité</li>
              <li>Quel retour sur investissement viser à court terme</li>
            </ul>
            <p className="section-text">Le Prosperian Score™ vous offre une lecture claire et objective de votre capacité d'accélération.</p>
            <p className="section-text">Et surtout, il vous permet de valider votre éligibilité au programme Prosperian, réservé aux entreprises capables de tirer parti de notre accompagnement.</p>
          </div>

          <div className="score-section-block">
            <h2 className="section-title">Une démarche sélective et engageante</h2>
            <p className="section-intro">Nous ne travaillons pas avec toutes les entreprises. Nous choisissons de collaborer uniquement avec celles qui :</p>
            <ul className="score-list">
              <li>Ont une offre B2B à valeur ajoutée, clairement positionnée</li>
              <li>Souhaitent s'engager dans une démarche d'amélioration continue</li>
              <li>Sont prêtes à structurer ou renforcer durablement leur prospection</li>
            </ul>
            <p className="section-text">Le scoring n'est pas une formalité. C'est une première étape de qualification mutuelle.</p>
          </div>
        </div>
      </div>

      <div className="score-cta">
        <div className="score-container">
          <h2 className="cta-title">DÉCOUVREZ VOTRE PROSPERIAN SCORE™</h2>
          <p className="cta-description">
            Rejoignez les entreprises qui transforment leur approche commerciale avec Prosperian.
          </p>
          <a href="https://www.videoask.com/fd8vz299c" target="_blank" rel="noopener noreferrer">
            <button className="cta-button">OBTENIR MON SCORE</button>
          </a>
        </div>
      </div>

      <div className="score-cta secondary">
        <div className="score-container">
          <h2 className="cta-title">Prêt à accélérer votre croissance ?</h2>
          <p className="cta-description">
            Découvrez comment notre méthodologie peut s'adapter à vos enjeux spécifiques.
          </p>
          <div className="cta-buttons">
            <a href="https://calendly.com/cb-prosperian/presentation-prosperian" target="_blank" rel="noopener noreferrer">
              <button className="cta-button">Demander une démo</button>
            </a>
            <a href="https://www.videoask.com/fd8vz299c" target="_blank" rel="noopener noreferrer">
              <button className="cta-button secondary">Tester mon éligibilité</button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Score; 